import React from 'react';
import { ImageProps } from '.';

const SvgZigzagSymbolRounded = ({ size = 76, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 1)) || 76} fill='none' viewBox='0 0 76 76' {...props}>
      <path
        fill='#FA6EE3'
        d='M0 11.482C0 5.141 5.122 0 11.44 0h53.12C70.877 0 76 5.14 76 11.482v53.036C76 70.859 70.878 76 64.56 76H11.44C5.123 76 0 70.86 0 64.518V11.482Z'
      />
      <path fill='#000' d='M23.622 15.856v10.415h12.719l-13.46 34.146h29.223V49.98h-12.62l13.362-34.123H23.622Z' />
    </svg>
  );
};

export default SvgZigzagSymbolRounded;
